// extracted by mini-css-extract-plugin
export default {"socialNetworks":"SocialNetworks_socialNetworks__WIt3D","youtube":"SocialNetworks_youtube__LaISF"};